import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import SupportPage from "./pages/SupportPage";
import VotePage from "./pages/VotePage";
// import other pages if any

export default function App() {
 return (
   <Router>
     <Routes>
       <Route path="/" element={<HomePage />} />
       <Route path="/support" element={<SupportPage />} />
       <Route path="/vote" element={<VotePage />} />
       {/* example for other pages: */}
       {/* <Route path="/about" element={<AboutPage />} /> */}
     </Routes>
   </Router>
 );
}